import { action, computed, observable } from 'mobx';
import axios from '../lib/axios';

class QuestionStore {
  @observable data = [];
  @observable sectionId;
  @observable isLoading = false;
  @observable isSending = false;
  @observable errorMessage;
  @observable questionId;

  @action answerQuestion(questionId, answerText, isFaq) {
    this.isSending = true;
    this.errorMessage = '';
    let params = { question_id: questionId, answer: answerText };
    if (isFaq)
      params.is_faq = isFaq;
    axios.post(`/answers`, params)
    .then((result) => {
      this.isSending = false;
      this.data = this.data.filter(question => question.id != questionId);
    })
    .catch((error) => {
      this.errorMessage = 'Dados inválidos, verifique.'
      this.isSending = false;
    });
  }

  @action setSectionId(sectionId) {
    this.sectionId = sectionId;
  }

  @action setQuestionId(questionId) {
    this.questionId = questionId === undefined ? undefined : parseInt(questionId);
  }

  @action fetchData() {
    this.isLoading = true;
    axios.get(`/questions/${this.sectionId}`)
      .then((result) => {
        this.isLoading = false;
        this.data = result.data;
        
        if (this.questionId) {
          this.data = this.data.sort((a,b) => {
            if (b.id === this.questionId)
              return 1;
            return -1;
          });
        }
        
      })
      .catch((error) => {
        this.isLoading = false;
      });
  }

  @computed get repliedQuestions() {
    return this.data.filter(question => question.was_answered).length;
  }

  @computed get existQuestions() {
    return this.data.filter(question => !question.was_answered).length;
  }

  @computed get questions() {
    return this.data.filter(question => !question.was_answered);
  }

  @computed get answers() {
    return this.data.filter(question => question.was_answered);
  }
}

export default new QuestionStore();



// WEBPACK FOOTER //
// ./src/stores/QuestionStore.js